module.exports = __webpack_public_path__ + "static/img/call.15d5fba9.png";